<template>
  <div>
    <div class="weui-cells__title">根据手机号查找朋友</div>
    <div class="weui-cells weui-cells_form">
      <div class="weui-cell weui-cell_vcode">
        <div class="weui-cell__hd">
          <label class="weui-label">手机号</label>
        </div>
        <div class="weui-cell__bd">
          <input class="weui-input" type="tel" v-model="phone" oninput="if(value.length>11)value=value.slice(0,11)" placeholder="请输入手机号" style="text-align: right;" />
        </div>
        <div class="weui-cell__ft">
          <button class="weui-vcode-btn" @click="check">精确查找</button>
        </div>
      </div>
    </div>

    <div class="userinfo">
      <div class="header">
        <img class="headerimg" :src="headimgBase64" alt="" style="margin-right:5px;display:block">
      </div>
      <div class="weui-cells">
        <div class="weui-cell">
          <div class="weui-cell__bd">
            <p>朋友姓名</p>
          </div>
          <div class="weui-cell__ft">{{userInfo.realname && userInfo.openid ? userInfo.realname:'待完善个人资料'}}</div>
        </div>
        <div class="weui-cell">
          <div class="weui-cell__bd">
            <p>朋友昵称</p>
          </div>
          <div class="weui-cell__ft">{{userInfo.nickname}}</div>
        </div>
        <div class="weui-cell">
          <div class="weui-cell__bd">
            <p>主手机号</p>
          </div>
          <div class="weui-cell__ft">{{userInfo.phoneMain}}</div>
        </div>
        <div class="weui-cell">
          <div class="weui-cell__bd">
            <p>副手机号</p>
          </div>
          <div class="weui-cell__ft">{{userInfo.phoneVice && userInfo.openid ? userInfo.phoneVice:'暂无'}}</div>
        </div>
      </div>
    </div>

    <div class="warehousing-footer-item sureinwarehousing" style="flex:2" @click="save">
      <a href="javascript:;">请为代取</a>
    </div>
  </div>
</template>

<script>
import weui from "weui.js";
import axios from "axios";
import config from "../../config/config.js";

export default {
  data() {
    return {
      encodeToken: "",
      token: "",
      toTakeId: "",
      phone: "",
      userInfo: {},
      headimgBase64: config.defaultImgBase64
    };
  },
  created() {
    this.toTakeId = this.$route.params.toTakeId;
    this.encodeToken = this.$route.params.token;
    this.token = decodeURIComponent(this.encodeToken);
    axios.defaults.headers["Authorization"] = "Bearer " + this.token;
  },
  methods: {
    check() {
      if (!this.phone || this.phone.length != 11) {
        weui.alert("请输入正确的手机号码");
        return;
      } else {
        let loading = weui.loading("查询中", {
          className: "custom-classname"
        });
        // 根据token查找微信用户信息
        axios
          .get("/api/user/wxuserInfo/" + this.phone)
          .then(response => {
            loading.hide(function() {});
            if (response.data.success) {
              this.userInfo = response.data.data;
              this.headimgBase64 =
                "data:image/png;base64," + this.userInfo.headimgBase64;
            } else {
              weui.alert(response.data.message);
            }
          })
          .catch(error => {
            loading.hide(function() {});
            weui.alert("获取用户信息失败");
          });
      }
    },
    save() {
      let that = this;
      if (!this.userInfo._id) {
        weui.alert("请先根据手机号查找您的朋友");
        return;
      } else {
        let params = {
          toTakeId: this.toTakeId,
          agentId: this.userInfo._id,
          agentOpenid: this.userInfo.openid,
          agent: this.userInfo.realname
            ? this.userInfo.realname
            : this.userInfo.nickname.substr(0, 4),
          agentPhone: this.phone
        };
        axios
          .put("/api/expressTosend/proxy/updateAgent", params)
          .then(res => {
            if (res.data.success) {
              weui.toast("请为代取成功", 1000);
              // 跳转回待取件列表
              that.$router.push("/expressTotakeList/ing/" + that.encodeToken);
            } else {
              weui.alert(res.data.message);
            }
          })
          .catch(err => {
            weui.alert("请为代取失败");
          });
      }
    }
  }
};
</script>

<style scoped>
.userinfo {
  margin: 20px;
  border: 1px solid #eee;
  padding: 20px 10px 10px 10px;
}
.header {
  display: flex;
  justify-content: center;
  align-items: center;
}
.headerimg {
  width: 100px;
  height: 100px;
  border-radius: 100px;
}
.warehousing-footer-item {
  flex: 1;
  font-size: 18px;
  text-align: center;
  background-color: #1aad19;
  margin-top: 10px;
  line-height: 50px;
}
.warehousing-footer-item a {
  color: #ffffff;
}
.weui-cells:last-child::after {
  border-bottom: none;
}
</style>





// WEBPACK FOOTER //
// src/components/operations/ProxyGet.vue